import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { Button, Input, Alert } from '../components/common'

function LoginPage() {
  const navigate = useNavigate()
  const { login } = useAuth()
  
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }))
    setError('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!formData.username || !formData.password) {
      setError('Username dan password harus diisi')
      return
    }

    setLoading(true)
    setError('')

    try {
      await login(formData.username, formData.password)
      navigate('/')
    } catch (err) {
      setError(err.message || 'Login gagal. Periksa username dan password.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo & Title */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-2xl shadow-lg mb-4">
            <span className="text-4xl">🖨️</span>
          </div>
          <h1 className="text-3xl font-bold text-white">SIM Percetakan</h1>
          <p className="text-blue-200 mt-2">INFINITE & NAJMI</p>
          <p className="text-blue-300 text-sm">v8.15 - Sistem Manajemen Produksi</p>
        </div>

        {/* Login Form */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-6 text-center">
            Masuk ke Akun Anda
          </h2>

          {error && (
            <div className="mb-4">
              <Alert type="error">{error}</Alert>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="Username"
              name="username"
              type="text"
              placeholder="Masukkan username"
              value={formData.username}
              onChange={handleChange}
              autoFocus
            />

            <Input
              label="Password"
              name="password"
              type="password"
              placeholder="Masukkan password"
              value={formData.password}
              onChange={handleChange}
            />

            <Button
              type="submit"
              variant="primary"
              size="lg"
              className="w-full mt-6"
              loading={loading}
            >
              {loading ? 'Memproses...' : 'Masuk'}
            </Button>
          </form>

          {/* Demo Users */}
          <div className="mt-6 pt-6 border-t">
            <p className="text-sm text-gray-500 text-center mb-3">Demo Users:</p>
            <div className="grid grid-cols-2 gap-2 text-xs">
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="font-medium">Admin</p>
                <p className="text-gray-500">admin / admin123</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="font-medium">Manager</p>
                <p className="text-gray-500">manager / manager123</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="font-medium">Operator</p>
                <p className="text-gray-500">operator / operator123</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-2">
                <p className="font-medium">Gudang</p>
                <p className="text-gray-500">gudang / gudang123</p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-blue-200 text-sm mt-6">
          &copy; 2024 INFINITE & NAJMI. All rights reserved.
        </p>
      </div>
    </div>
  )
}

export default LoginPage
